var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-message"},[(_vm.service.length == 0)?_c('div',{staticClass:"emptyMessage"},[_vm._v(" 暂无数据 ")]):_vm._e(),(_vm.service.length > 0)?_c('div',{staticStyle:{"width":"100%","height":"8.0416rem","margin-top":"1rem"},attrs:{"id":"main1"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }